import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const AnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Make sure gtag exists (it was defined in index.html)
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      // Send a page_view event to GA4 on route change
      window.gtag('event', 'page_view', {
        page_path: location.pathname + location.search,
      });
    }
  }, [location]); // Re-run this effect every time the location changes

  return null; // This component doesn't render anything visually
};

export default AnalyticsTracker;